import { SvgIcon, SvgIconProps } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export const TasksIcon = ({
  color = RoutalPalette.neutral60,
  ...props
}: { color?: string } & Omit<SvgIconProps, `color`>) => {
  return (
    <SvgIcon {...props} viewBox="0 0 14 15" style={{ width: `16px`, height: `16px`, ...props.style }}>
      <g fill="none">
        <path
          d="M3.52647 1.41757L3.53874 1.41817H3.55101H12.441H12.4534L12.4658 1.41756C12.7801 1.40196 13.0539 1.64345 13.075 1.96294V11.0403C13.0538 11.3576 12.7823 11.6014 12.4656 11.5858L12.4533 11.5852H12.441H3.55101H3.53861L3.52623 11.5858C3.21192 11.6014 2.93817 11.3599 2.91699 11.0404V1.96309C2.93825 1.64573 3.20971 1.402 3.52647 1.41757Z"
          stroke={color}
        />
        <path
          d="M10.9837 13.911H1.79403C1.1477 13.911 0.624756 13.3868 0.624756 12.739V2.3435"
          stroke={color}
          strokeLinecap="round"
        />
        <path
          d="M5.34888 6.36622L7.25262 8.40408L10.6371 4.77598"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
